<template>
  <div class="fixed top-0 left-0 h-screen z-50 w-screen bg-dark-transparent">
    <div class="absolute bottom-0 h-2/3 w-screen rounded-3xl rounded-b-none bg-gray-50">
      <div class="relative px-6 py-6">
        <div>
          <p class="text-base font-extrabold inline-block">Select Category</p>
          <div class="float-right inline-block" @click="close">
            <close-icon :width="'w-4'" :color="'text-nw-red'"></close-icon>
          </div>
        </div>
        <div class="pt-1" v-for="(category, index) in categories" :key="index" @click="selectCategory(index)">
          <input-text type="text" class="pb-3" readonly :value="category"></input-text>
          <div class="absolute right-0 -mt-9 mr-6" v-if="index == index_val">
            <click-icon></click-icon>
          </div>
        </div>
        <div @click="close" class="text-center bg-nw-red rounded w-full py-3 text-white mt-3">Continue</div>
      </div>
    </div>
  </div>
</template>

<script>
import ClickIcon from '../icons/ClickIcon.vue'
import CloseIcon from '../icons/CloseIcon.vue'
import InputText from '../inputs/InputText.vue'
export default {
  props: {
    category: String
  },
  components: { CloseIcon, InputText, ClickIcon },
  data() {
    return {
      categories: ['Clothing', 'Electronics', 'Groceries', 'Car Parts', 'Documents', 'Health Products', 'Others'],
      index_val: -1
    }
  },
  methods: {
    close() {
      this.$emit('category', false)
    },
    selectCategory(index) {
      this.index_val = index
      this.$emit('selected-category', this.categories[index])
    }
  },
  mounted() {
    if (this.category != '') {
      for (let index = 0; index < this.categories.length; index++) {
        if (this.categories[index] == this.category) {
          this.index_val = index
        }
      }
    }
  }
}
</script>
